import i18n from '@/lang/i18n';

export const DEFAULT_SENSOR_SETTING = {
  max_scale: null,
  min_scale: null
};

export const ICON_CAMERA = 'videocam'
export const ICON_TDSENSOR = 'device_thermostat'
export const ICON_ETC = 'router'
export const ICON_NONE = 'remove'

export const TYPE_CAMERA = 'camera'
export const TYPE_TDSENSOR = 'tdsensor'
export const TYPE_ETC = 'etc'

export const CONNECT_STATUS_ON = 'ON'

export const PERIPHERAL_EQUIPMENT_LIST = [
  {
    icon: ICON_CAMERA,
    type: TYPE_CAMERA,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.cameraFront'),
    path: 'common.camera_on',
    value: 'enabledCameraFront'
  },
  {
    icon: ICON_CAMERA,
    type: TYPE_CAMERA,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.cameraRear'),
    path: 'record.camr_on',
    value: 'enabledCameraRear'
  },
  {
    icon: ICON_CAMERA,
    type: TYPE_CAMERA,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.cameraInner'),
    path: 'record.cami_on',
    value: 'enabledCameraInner'
  },
  {
    icon: ICON_CAMERA,
    type: TYPE_CAMERA,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.cameraSide'),
    path: 'record.cams_on',
    value: 'enabledCameraSide'
  },
  {
    icon: ICON_TDSENSOR,
    type: TYPE_TDSENSOR,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.tdsensorCh1'),
    path: 'tdsensor.tds1',
    value: 'enabledTdsensorCh1'
  },
  {
    icon: ICON_TDSENSOR,
    type: TYPE_TDSENSOR,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.tdsensorCh2'),
    path: 'tdsensor.tds2',
    value: 'enabledTdsensorCh2'
  },
  {
    icon: ICON_TDSENSOR,
    type: TYPE_TDSENSOR,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.tdsensorCh3'),
    path: 'tdsensor.tds3',
    value: 'enabledTdsensorCh3'
  },
  {
    icon: ICON_TDSENSOR,
    type: TYPE_TDSENSOR,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.tdsensorCh4'),
    path: 'tdsensor.tds4',
    value: 'enabledTdsensorCh4'
  },
  {
    icon: ICON_ETC,
    type: TYPE_ETC,
    name: i18n.global.t('pages.vehicles.peripheralEquipmentName.etc'),
    path: 'etc.connect',
    value: 'enabledEtc'
  },
]
